import { FuseAnimate } from "@fuse";
import _ from "@lodash";
import { Fab, Tab, Tabs, withStyles } from "@material-ui/core";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import EmpresaFormaPagamentoApp from "app/ERP/EmpresaFormaPagamento/EmpresaFormaPagamentoApp";
import withReducer from "app/store/withReducer";
import React from "react";
import { MdAdd } from "react-icons/md";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import EmpresaPessoaOrcamentoApp from "../../ERP/EmpresaPessoaOrcamento/EmpresaPessoaOrcamentoApp";
import * as Actions from "./Store/Actions/TarefaApontamentoActions";
import TarefaApontamentoReducer from "./Store/Reducers/TarefaApontamentoReducer";
import TarefaApontamentoDialog from "./TarefaApontamentoDialog";
import TarefaApontamentoList from "./TarefaApontamentoList";
import TarefaApontamentoNovoDialog from "./TarefaApontamentoNovoDialog";
import TarefaApontamentoReciboDialog from "./TarefaApontamentoReciboDialog";

const styles = () => ({
    addButton: {
        position: "absolute",
        right: 20,
        bottom: 20,
        zIndex: 99,
        //color: theme.palette.text.primary,
    }
});

class TarefaApontamentoApp extends XAPPComponent {

    state = {
        natureza: -1,
        openGerarPedido: null,
        idtarefaprocessoapontamento: null
    };

    componentDidMount() {
        if (!this.props.showDialog) {
            if (!_.isNull(this.props.apontamento)) {
                this.setState({ natureza: Number.parseInt(this.props.apontamento.split(",")[0]) });
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { showDialog = false, TarefaApontamento, xappRouteParams, apontamento, foreingKey, id, idpessoaformulario } = this.props;
        const form = this.state;

        if (showDialog && !_.isNull(TarefaApontamento.dialog) && TarefaApontamento.dialog === id &&
            apontamento.split(",")[0] !== form.natureza.toString()) {
            if (!_.isNull(apontamento) && form.natureza === -1) {
                this.setState({ natureza: Number.parseInt(apontamento.split(",")[0]) });
            }
        }

        if (prevState.natureza === -1 && !_.isEqual(prevState.natureza, form.natureza)) {
            if (apontamento === "20") {
                this.props.listEmAberto(xappRouteParams, { idtarefaprocesso: foreingKey, idpessoaformulario });
            }
            else {
                this.props.list("SELECIONAR", xappRouteParams, foreingKey);
            }
        }


        if (showDialog && _.isNull(TarefaApontamento.dialog) &&
            !_.isEqual(prevProps.dialog, TarefaApontamento.dialog) && form.natureza !== -1) {
            this.setState({ natureza: -1, idtarefaprocessoapontamento: null });
        }
    }

    handleChangeTab = (event, _AValue) => {
        this.setState({ natureza: _AValue });
    };

    openDialog = (_ANome, _AItem) => {
        var obj = JSON.parse(JSON.stringify(this.state));
        obj[_ANome] = _AItem;
        if (_.isObject(_AItem)) {
            obj.idtarefaprocessoapontamento = _AItem.idtarefaprocessoapontamento;
        }
        this.setState(obj);
    };

    changeTabPedido = () => {
        const { natureza } = this.state;
        if (natureza === 7) {
            this.handleChangeTab(null, 0);
        }
        else {
            this.handleChangeTab(null, 4);
        }
        this.props.list("SELECIONAR", this.props.xappRouteParams, this.props.foreingKey);
    };

    gerarPedido = (_AItem) => {
        const { save, xappRouteParams } = this.props;
        save("GERARPEDIDO", _AItem, xappRouteParams, _AItem.idtarefaprocesso);
        this.changeTabPedido();
    };

    renderContent() {
        const { classes, readOnly, openNovoDialog, xappRouteParams, foreingKey, TarefaApontamento, apontamento, profissional, idpessoaformulario = null, pessoaformulario } = this.props;
        const { natureza } = this.state;
        return (
            <React.Fragment>
                <div className="hidden">
                    <EmpresaFormaPagamentoApp
                        xappRouteParams={xappRouteParams}
                        isLookup={true}
                        multiSelect={false}
                        id="FormaPagamento"
                        key="FormaPagamento"
                        label="Forma de pagamento"
                        target="spvwempresaformapagamentolookup"
                        autoSearch={true}
                    />
                </div>
                <React.Fragment>
                    {!_.isNull(apontamento) && apontamento.split(",").length > 1 &&
                        <Tabs
                            value={natureza}
                            onChange={this.handleChangeTab}
                            indicatorColor="secondary"
                            textColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto"
                            classes={{ root: "w-full h-64" }}
                        >
                            {apontamento.includes("7") &&
                                <Tab value={7} classes={{ root: "h-40 normal-case" }} label="Orçamento" />
                            }
                            {apontamento.includes("0") &&
                                <Tab value={0} classes={{ root: "h-40 normal-case" }} label="Pedido" />
                            }
                            {apontamento.includes("1") &&
                                <Tab value={1} classes={{ root: "h-40 normal-case" }} label="Caixa" />
                            }
                            {apontamento.includes("3") &&
                                <Tab value={3} classes={{ root: "h-40 normal-case" }} label="Estoque" />
                            }
                            {apontamento.includes("18") &&
                                <Tab value={18} classes={{ root: "h-40 normal-case" }} label="Orçamento" />
                            }
                            {apontamento.includes("4") &&
                                <Tab value={4} classes={{ root: "h-40 normal-case" }} label="Produtos e serviços" />
                            }
                            {apontamento.includes("5") &&
                                <Tab value={5} classes={{ root: "h-40 normal-case" }} label="Caixa" />
                            }
                            {apontamento.includes("20") &&
                                <Tab value={20} classes={{ root: "h-40 normal-case" }} label="Checkout" />
                            }
                        </Tabs>
                    }
                    {!_.isNull(apontamento) && ![18].includes(natureza) &&
                        <TarefaApontamentoList
                            foreingKey={foreingKey}
                            xappRouteParams={xappRouteParams}
                            natureza={natureza}
                            handleChangeTab={this.handleChangeTab}
                            openDialog={this.openDialog}
                            pessoaformulario={pessoaformulario}
                            gerarPedido={this.gerarPedido}
                            apontamentos={TarefaApontamento.data}
                            profissional={profissional}
                            showRecibo={true}
                            readOnly={readOnly}
                        />
                    }
                    {!_.isNull(apontamento) && !_.isNull(idpessoaformulario) && [18].includes(natureza) &&
                        <EmpresaPessoaOrcamentoApp
                            foreingKey={foreingKey}
                            idparent={idpessoaformulario}
                            xappRouteParams={xappRouteParams}
                            datapessoa={pessoaformulario}
                            changeTabPedido={this.changeTabPedido}
                        />
                    }
                </React.Fragment>
                {!_.isNull(apontamento) && [3, 4, 7].includes(natureza) &&
                    <FuseAnimate animation="transition.expandIn" delay={300}>
                        <Fab
                            id={`fab-add-apontamento-${natureza}`}
                            color="primary"
                            aria-label="add"
                            className={classes.addButton}
                            onClick={() => openNovoDialog({ natureza: natureza })}
                        >
                            <MdAdd className="text-24 text-white" />
                        </Fab>
                    </FuseAnimate>
                }
            </React.Fragment>
        );
    }

    render() {
        const { openFirstItem = false, showDialog = false, children = null, apontamento, openDialog, id, gerarGuia,
            idtarefaprocessoapontamento, xappRouteParams, foreingKey, idpessoaformulario, pessoaformulario, profissional = null, callback = null } = this.props;
        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    {showDialog ?
                        <React.Fragment>
                            <div className="w-full cursor-pointer" style={{ display: "contents" }} onClick={() => openDialog(id)}>
                                {!_.isNull(children) && children}
                            </div>
                            <TarefaApontamentoDialog
                                id={id}
                                apontamento={apontamento}
                            >
                                {this.renderContent()}
                            </TarefaApontamentoDialog>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {openFirstItem ?
                                <div
                                    className="w-full cursor-pointer"
                                    style={{ display: "contents" }}
                                    onClick={() => {
                                        if (!_.isNull(idtarefaprocessoapontamento)) {
                                            gerarGuia(xappRouteParams, idtarefaprocessoapontamento);
                                        }
                                    }}
                                >
                                    {!_.isNull(children) && children}
                                </div>
                                :
                                <React.Fragment>
                                    {this.renderContent()}
                                </React.Fragment>
                            }
                        </React.Fragment>
                    }
                    <TarefaApontamentoNovoDialog
                        foreingKey={foreingKey}
                        xappRouteParams={xappRouteParams}
                        openDialog={this.openDialog}
                        idpessoaformulario={idpessoaformulario}
                        pessoaformulario={pessoaformulario}
                        profissional={profissional}
                        callback={callback}
                    />
                    <TarefaApontamentoReciboDialog
                        xappRouteParams={xappRouteParams}
                        foreingKey={foreingKey}
                        profissional={profissional}
                    />
                </CatchErro>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openNovoDialog: Actions.openNovoDialog,
        openDialog: Actions.openDialog,
        list: Actions.list,
        save: Actions.save,
        listEmAberto: Actions.listEmAberto,
        gerarGuia: Actions.gerarGuia,
        getTituloByPedido: Actions.getTituloByPedido,
    }, dispatch);
}

function mapStateToProps({ TarefaApontamento }) {
    return {
        TarefaApontamento: TarefaApontamento,
    };
}

export default withReducer("TarefaApontamento", TarefaApontamentoReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(TarefaApontamentoApp))));
